var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4354 7.28086L13.3947 6.26427C14.4113 5.19041 14.8695 3.9662 13.2873 2.46995C11.7051 0.98086 10.5096 1.50347 9.49299 2.57734L3.61537 8.79859C3.39344 9.03484 3.17867 9.50018 3.13571 9.82234L2.87083 12.1419C2.77776 12.9795 3.37912 13.5522 4.20958 13.409L6.51481 13.0153C6.83696 12.958 7.28799 12.7218 7.50992 12.4784L10.3378 9.48586",
    stroke: "#1C80D2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51221 3.61523C8.82005 5.59114 10.4237 7.10171 12.4139 7.30217",
    stroke: "#1C80D2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14771 15.75H10.0227",
    stroke: "#1C80D2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8865 15.75H15.0342",
    stroke: "#1C80D2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEditIcon);
export default __webpack_public_path__ + "static/media/blueEditIcon.1fb2ffe961d69fbea0148e6334bfc8f4.svg";
export { ForwardRef as ReactComponent };